import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import { Card } from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import Table, { Column } from "../../components/tables/table";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import { useAppDispatch, useAppSelector } from "../../Hooks";
import { getOrderReviewsData } from "../../features/orderReviews";
import { IOrderReviewItem } from "../../types/features/orderReviewsSlice";
import { Star, StarBorder } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const OrderReviews: React.FC = () => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState<IOrderReviewItem[]>([]);
  const [open, setOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState("");
  const {
    data: orderData,
    total,
    status,
  } = useAppSelector((state: any) => state.orderReviews);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const columns: Column[] = [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      align: "center",
      cell: (info: any) => (
        <span style={{ fontWeight: "500" }}>{info.getValue()}</span>
      ),
    },
    {
      header: "Name",
      accessorKey: "user_id",
      id: "owner_name",
      align: "left",
      cell: (info: any) => (
        <strong style={{ fontWeight: "600" }}>
          {info.getValue()?.owner_name || ""}
        </strong>
      ),
    },
    // {
    //   header: "Order Id",
    //   accessorKey: "order_id",
    //   id: "order_id",
    //   align: "left",
    //   cell: (info: any) => <strong>{info.getValue()}</strong>,
    // },
    {
      header: "Sale Order Requisition No",
      accessorKey: "SalesOrder",
      id: "SalesOrder",
      align: "left",
      cell: (info: any) => (
        <strong style={{ fontWeight: "500" }}>{info.getValue()}</strong>
      ),
    },
    {
      header: "Ratings",
      accessorKey: "Ratings",
      id: "Ratings",
      align: "left",
      cell: (info: any) => {
        const rating = Number(info.getValue()) || 0;

        return (
          <span
            style={{ display: "flex", alignItems: "center", color: "#1b3648" }}
          >
            {[...Array(5)].map((_, index) =>
              index < rating ? (
                <Star key={index} fontSize="small" />
              ) : (
                <StarBorder key={index} fontSize="small" />
              )
            )}
          </span>
        );
      },
    },

    {
      header: "Review",
      accessorKey: "Review",
      id: "Review",
      align: "left",
      cell: (info: any) => {
        const fullReview = info.getValue() || "";
        const words = fullReview.split(" ");
        const shortReview = words.slice(0, 8).join(" ");
        const ellipsis = words.length > 8 ? "..." : "";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              maxWidth: "250px",
            }}
          >
            <span
              title={fullReview}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: 500,
                fontSize: "14px",
                flex: "1 1 auto",
              }}
            >
              {shortReview + ellipsis}
            </span>
            {words.length > 8 && (
              <VisibilityIcon
                onClick={() => {
                  setSelectedReview(fullReview);
                  setOpen(true);
                }}
                style={{
                  cursor: "pointer",
                  color: "#1b3648",
                  width: "20px",
                  height: "20px",
                  padding: "2px",
                  border: "1px solid #1b3648",
                  borderRadius: "5px",
                }}
              />
            )}
          </div>
        );
      },
    },
    // {
    //   header: "Actions",
    //   id: "actions",
    //   align: "center",
    //   cell: (info: any) => {
    //     const id = info.row.original._id;
    //     const snp_no = info.row.original.sap_no;
    //     const status = info.row.original.status;

    //     return (
    //       <div>
    //         {
    //           (status !== 'ordered') && (
    //             <IconButton
    //               onClick={() => {
    //                 // dispatch(updateOrderReviewDetailData({ id, data: { status: 'ordered' } }))
    //                 setUpdate(!update);
    //                 alert('Order added to SAP')
    //               }}
    //             >
    //               <IoMdAdd />
    //             </IconButton>
    //           )
    //         }
    //         {
    //           (status !== 'approve') && (
    //             <IconButton
    //               onClick={() => {
    //                 // dispatch(updateOrderReviewDetailData({ id, data: { status: 'approve' } }))
    //                 setUpdate(!update);
    //               }}
    //             >
    //               <FaCheck />
    //             </IconButton>
    //           )
    //         }

    //         {
    //           (status === 'pending' || status === 'approve') &&
    //           (<IconButton
    //             onClick={() => {
    //               // dispatch(updateOrderReviewDetailData({ id, data: { status: 'reject' } }))
    //               setUpdate(!update);
    //             }}
    //           >
    //             <ImCross />
    //           </IconButton>)
    //         }
    //         <IconButton onClick={() => navigate(`/order/view/${id}`)}>
    //           <FaEye />
    //         </IconButton>
    //       </div >
    //     );
    //   },
    // },
  ];

  useEffect(() => {
    dispatch(getOrderReviewsData({ page: pageIndex, limit: pageSize }));
  }, [dispatch, pageIndex, pageSize]);

  useEffect(() => {
    // // // console.log({ orderData });

    if (status && orderData) {
      setData(orderData);
      setTotalRows(total || 0);
    }
  }, [status, orderData, total]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={3}
          py={2}
        >
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Order Reviews
          </SoftTypography>
        </SoftBox>
        <Table
          columns={columns}
          data={data}
          pageIndex={pageIndex}
          pageSize={pageSize}
          totalRows={totalRows}
          onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
          onPageSizeChange={(newPageSize: number) => setPageSize(newPageSize)}
        />
      </Card>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: 24,
            p: 4,
            width: 800,
            maxWidth: "100%",
            position: "relative", // important for absolute close icon
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#666",
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Full Review
          </Typography>
          <Typography
            variant="body1"
            style={{ fontSize: "14px", fontWeight: "500" }}
          >
            {selectedReview}
          </Typography>
        </Box>
      </Modal>
    </DashboardLayout>
  );
};

export default OrderReviews;
